@if(competencia){
  <app-crud-edit
    #editCompetencia
          [fields]="fields"
          [description]="'Modifica los datos de la competencia seleccionada'"
          [apiService]="apiService"
          [id] = "id"
          [backButton]="false"
          [actionButtons]="false"
          [goBackInModal]="false"
          (selectFieldValueEmit)="filterSelectsByNivel($event)"
          (formSubmitEvent)="submit()"
    ></app-crud-edit>
}@else{
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
